import React from "react";
import styles from "./Statusview.module.scss";

type StatusProps = {
	status: string | undefined;
	green?: string;
	red?: string;
	orange?: string;
	newOrange?: string;
	grey?: string;
	blue?: string;
	value?: string;
	setValue?: React.Dispatch<React.SetStateAction<string>>;
	style?: React.CSSProperties;
};
const StatusView = ({
	status,
	green,
	orange,
	newOrange,
	red,
	blue,
	grey,
	value,
	setValue,
	style,
}: StatusProps) => {
	return (
		<div className={styles.wrapper} style={style}>
			{status === red ? (
				<div className={styles.lost}>{red}</div>
			) : status === orange ? (
				<div className={styles.processing}>{orange}</div>
			) : status === newOrange ? (
				<div className={styles.grey}>{newOrange}</div>
			) : status === green ? (
				<div className={styles.completed}>{green}</div>
			) : status === blue ? (
				<div className={styles.review}>{blue}</div>
			) : status === grey ? (
				<div className={styles.declined}>{grey}</div>
			) : null}
		</div>
	);
};

export default StatusView;
